<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">

      <li class="nav-item" v-if="this.$store.state.login.userType != '기타사용자'">
        <sidenav-item url="/main-page" :class="getRoute() === 'main-page' ? 'active' : ''" navText="메인">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-else>
        <sidenav-item url="/devMain" :class="getRoute() === 'devMain' ? 'active' : ''" navText="개발팀 메인">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      
      <li class="nav-item" v-if="this.$store.state.login.userType != '기타사용자'">
        <a class="btn shadow-none nav-link" type="button" data-bs-toggle="collapse" data-bs-target=".settingsCollapse01" aria-expanded="false" aria-controls="settingsCollapse01">
          <i class="fas fa-user text-onmaum text-sm opacity-10"></i>
          <span class="nav-link-text ms-1">고객 정보</span>
        </a>
        <div class="collapse settingsCollapse01 ps-3">
          <sidenav-item url="/customer-info-dental" :class="getRoute() === 'customer-info-dental' ? 'active' : ''" navText="치과">
            <template v-slot:icon>
              <i class="fas fa-tooth onmaum-text-dental text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <sidenav-item url="/customer-info-finger" :class="getRoute() === 'customer-info-finger' ? 'active' : ''" navText="지문">
            <template v-slot:icon>
              <i class="fas fa-fingerprint text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <sidenav-item url="/customer-info-pet" :class="getRoute() === 'customer-info-pet' ? 'active' : ''" navText="혼디도랑">
            <template v-slot:icon>
              <i class="fas fa-dog onmaum-text-pet text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <sidenav-item url="/customer-info-sns" :class="getRoute() === 'customer-info-sns' ? 'active' : ''" navText="사이트 & SNS">
            <template v-slot:icon>
              <i class="fas fa-tablet-alt onmaum-text-sns text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <sidenav-item url="/customer-info-hospital" :class="getRoute() === 'customer-info-hospital' ? 'active' : ''" navText="동물병원">
            <template v-slot:icon>
              <i class="fas fa-hospital-alt text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </div>
      </li>

      <!-- <li class="nav-item" v-if="this.$store.state.login.userType != '기타사용자'">
        <sidenav-item url="/customer-manage" :class="getRoute() === 'customer-manage' ? 'active' : ''" navText="고객 관리">
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <!-- <li class="nav-item" v-if="this.$store.state.login.userType == '관리자'">
        <sidenav-item url="/planner-info" :class="getRoute() === 'planner-info' ? 'active' : ''" navText="플래너 정보">
          <template v-slot:icon>
            <i class="ni ni-circle-08 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="nav-item" v-if="this.$store.state.login.userType == '관리자'">
        <sidenav-item url="/planner-manage" :class="getRoute() === 'planner-manage' ? 'active' : ''" navText="플래너 관리">
          <template v-slot:icon>
            <i class="ni ni-badge text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="this.$store.state.login.userType == '관리자' || this.$store.state.login.userType == '플래너'">
        <a class="btn shadow-none nav-link" type="button" data-bs-toggle="collapse" data-bs-target=".statisticsCollapse" aria-expanded="false" aria-controls="statisticsCollapse">
          <i class="fas fa-chart-bar onmaum-text-contract text-sm opacity-10"></i>
          <span class="nav-link-text ms-1">DB 현황</span>
        </a>
        <div class="collapse statisticsCollapse ps-3">

          <!-- 치과DB건수 통계 -->
          <sidenav-item url="/statistics-dental" :class="getRoute() === 'statistics-dental' ? 'active' : ''" navText="치과DB건수" v-if="this.$store.state.login.userType == '관리자'">
            <template v-slot:icon>
              <i class="fas fa-tooth onmaum-text-dental text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <!-- 컴플레인 통계 -->
          <sidenav-item url="/statistics-complain" :class="getRoute() === 'statistics-complain' ? 'active' : ''" navText="컴플레인" v-if="this.$store.state.login.userType == '관리자'">
            <template v-slot:icon>
              <i class="fas fa-frown text-danger text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <!-- 치과 DB 관리 -->
          <sidenav-item url="/db-manage" :class="getRoute() === 'db-manage' ? 'active' : ''" navText="DB 관리" v-if="this.$store.state.login.userType == '관리자'">
            <template v-slot:icon>
              <i class="fas fa-user-cog onmaum-text-dental text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <!-- DB요청 -->
          <sidenav-item url="/request-db" :class="getRoute() === 'request-db' ? 'active' : ''" navText="DB 요청">
            <template v-slot:icon>
              <i class="fas fa-user-plus onmaum-text-dental text-sm opacity-10"></i>
            </template>
          </sidenav-item>

        </div>
      </li>

      <li class="nav-item" v-if="this.$store.state.login.userType != '기타사용자' && this.$store.state.login.userType != '펫'">
        <sidenav-item url="/dental-form" :class="getRoute() === 'dental-form' ? 'active' : ''" navText="치과청구확인서 양식">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="this.$store.state.login.userType != '기타사용자' && this.$store.state.login.userType != '펫'">
        <sidenav-item url="/itsm" :class="getRoute() === 'itsm' ? 'active' : ''" navText="사이트 수정 요청">
          <template v-slot:icon>
            <i class="ni ni-settings onmaum-text-itsm text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="this.$store.state.login.loginID == 'isaack0427' || (this.$store.state.login.userType == '기타사용자' && (this.$store.state.login.loginID == 'developer01' || this.$store.state.login.loginID == 'developer02'))">
        <a class="btn shadow-none nav-link" type="button" data-bs-toggle="collapse" data-bs-target=".hondiCollapse" aria-expanded="false" aria-controls="hondiCollapse">
          <i class="fas fa-store-alt onmaum-text-hondi text-sm opacity-10"></i>
          <span class="nav-link-text ms-1">혼디도랑</span>
        </a>
        <div class="collapse hondiCollapse ps-3">
          <!-- 메뉴 관리 -->
          <sidenav-item url="/menu-manage" :class="getRoute() === 'menu-manage' ? 'active' : ''" navText="메뉴 관리">
            <template v-slot:icon>
              <i class="fas fa-list onmaum-text-red text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <!-- 입양 현황 관리 -->
          <sidenav-item url="/adoption-info" :class="getRoute() === 'adoption-info' ? 'active' : ''" navText="입양 현황 관리">
            <template v-slot:icon>
              <i class="fas fa-door-open onmaum-text-pet text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <!-- 동물병원 관리 -->
          <sidenav-item url="/hospital-manage" :class="getRoute() === 'hospital-manage' ? 'active' : ''" navText="동물병원 관리">
            <template v-slot:icon>
              <i class="fas fa-hospital-alt text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <!-- 구조 현황 관리 -->
          <sidenav-item url="/rescue-manage" :class="getRoute() === 'rescue-manage' ? 'active' : ''" navText="구조 현황 관리">
            <template v-slot:icon>
              <i class="fas fa-briefcase-medical onmaum-text-rescue text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </div>
      </li>
      
      <li class="nav-item" v-if="this.$store.state.login.userType != '펫'">
        <a class="btn shadow-none nav-link" type="button" data-bs-toggle="collapse" data-bs-target=".settingsCollapse" aria-expanded="false" aria-controls="settingsCollapse">
          <i class="ni ni-settings-gear-65 text-dark text-sm opacity-10"></i>
          <span class="nav-link-text ms-1">설정</span>
        </a>
        <div class="collapse settingsCollapse ps-3">
          <!-- 사이트 계정 관리 -->
          <sidenav-item url="/setting" :class="getRoute() === 'setting' ? 'active' : ''" navText="사이트 계정 관리" v-if="this.$store.state.login.userType == '관리자'">
            <template v-slot:icon>
              <i class="fas fa-unlock-alt text-dark text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <!-- 공지사항 관리 -->
          <sidenav-item url="/notice-manage" :class="getRoute() === 'notice-manage' ? 'active' : ''" navText="공지사항 관리" v-if="this.$store.state.login.userType == '관리자'">
            <template v-slot:icon>
              <i class="fas fa-bullhorn text-danger text-sm opacity-10"></i>
            </template>
          </sidenav-item>
          
          <!-- 알람 설정 -->
          <sidenav-item url="/alarm-manage" :class="getRoute() === 'alarm-manage' ? 'active' : ''" navText="알림 설정" v-if="this.$store.state.login.loginID == 'isaack0427'">
            <template v-slot:icon>
              <i class="far fa-bell onmaum-text-alarm text-lg opacity-10"></i>
            </template>
          </sidenav-item>

          <!-- 비밀번호 변경 -->
          <sidenav-item url="/change-password" :class="getRoute() === 'change-password' ? 'active' : ''" navText="비밀번호 변경">
            <template v-slot:icon>
              <i class="fas fa-user-lock text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>

          <!-- 개발용 -->
          <sidenav-item url="/devTools" :class="getRoute() === 'devTools' ? 'active' : ''" navText="개발용(주의!)" v-if="this.$store.state.login.loginID == 'isaack0427'">
            <template v-slot:icon>
              <i class="fas fa-code text-danger text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </div>
      </li>

    </ul>

  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "온마음",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  components: {
    SidenavItem,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    }
  }
};
</script>
